import { configureStore, combineReducers } from '@reduxjs/toolkit';

// Slice reducers
import classroomReducer from './classroomSlice';
import examReducer from './examSlice';
import coursesReducer from './coursesSlice';
import profileReducer from './profileSlice';
import courseDetailsReducer from './courseDetailsSlice';
import authReducer from './authSlice';
import contentReducer from './contentSlice';
import taskTimerReducer from './taskTimerSlice';
import activitiesReducer from './activitiesSlice';

// 🔹 Load from localStorage
const loadProfileFromLocalStorage = () => {
  try {
    const savedProfile = localStorage.getItem('studentProfile');
    return savedProfile ? JSON.parse(savedProfile) : null;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('❌ Failed to load studentProfile from localStorage:', err);
    return null;
  }
};

const preloadedState = {
  profile: {
    profile: loadProfileFromLocalStorage(),
  },
};

// Combine all reducers
const appReducer = combineReducers({
  courseDetails: courseDetailsReducer,
  classroom: classroomReducer,
  exam: examReducer,
  courses: coursesReducer,
  profile: profileReducer,
  auth: authReducer,
  content: contentReducer,
  taskTimer: taskTimerReducer,
  activities: activitiesReducer,
});

// Root reducer that can reset all state on logout
const rootReducer = (state, action) => {
  // When RESET_ALL action is dispatched, clear all state
  if (action.type === 'RESET_ALL') {
    // Clear all localStorage
    localStorage.clear();
    sessionStorage.clear();

    // Return undefined to reset to initial state
    state = undefined;
  }

  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  devTools: true,
});

export default store;
